module.exports = __webpack_public_path__ + "media/images/flags/ph-beb5ee035e68b026702a02922caa8290.svg";